// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import { MdSortByAlpha, MdWhatshot } from 'react-icons/md';

import cx from 'classnames';
import './ProductsTagsTab.scss';

type Props = {
  sort: ?string,
};

const ProductsTagsTab = ({ sort }: Props) => (
  <div className="ProductsTagsTab">
    <Link className={cx({ active: sort === 'popular' })} to="/products/tags?sort=popular">
      <MdWhatshot />
      인기순
    </Link>
    <Link className={cx({ active: sort === 'name' })} to="/products/tags?sort=name">
      <MdSortByAlpha />
      이름순
    </Link>
  </div>
);

ProductsTagsTab.defaultProps = {
  sort: 'popular',
};

export default ProductsTagsTab;



// WEBPACK FOOTER //
// ./src/components/tags/ProductsTagsTab/ProductsTagsTab.js